// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QMdz","colBig":"styles_colBig__1Zocn","colSmall":"styles_colSmall__230FO"};